import UsercenterModel from '@/models/usercenter'
import Avatar from '@/assets/images/l-avatar.png'

const userModel = new UsercenterModel()

const MUTATION_TYPE = {
  SET_USER: 'SET_USER',
}

const user = {
  namespaced: true,
  state: {
    user: null, //当前登录用户信息
  },
  getters: {
    user: (state) => state.user,
  },
  mutations: {
    [MUTATION_TYPE.SET_USER](state, info) {
      state.user = {
        ...info,
        id: info.userId || info.id,
      }
    },
  },
  actions: {
    [MUTATION_TYPE.SET_USER](context) {
      return new Promise((resolve, reject) => {
        userModel
          .getUser()
          .then((res) => {
            let resData = res.data
            resData.headImg =
              resData.headImg == '' || resData.headImg == null
                ? Avatar
                : resData.headImg
            context.commit(MUTATION_TYPE.SET_USER, resData)
            resolve(true)
          })
          .catch(() => {
            reject()
          })
      })
    },
    setAccount({ commit }, platform) {
      commit(MUTATION_TYPE.SET_USER, platform)
    },
  },
}

export default user
